import { trackButtonEvent } from 'lib/analytics';

export const buttonEventHandler = (
  buttonName,
  location = window.location.href,
  properties = {},
) => {
  // ANALYTICS
  trackButtonEvent(buttonName, location, properties);
};
